<template>
    <div class=" ">
        <div class=" ">
            <div >

              <div class="form-group">
                <div class="row">
                  <label for="" class="pt-2 col-md-4">{{showTitle}}</label>
                </div>
                <div class="row d-flex justify-content-center align-items-center">
                  <label for="" class="text-center"> Tipo de archivos permitidos: </label>
                  <ul v-if="extensions" class="tagd d-flex justify-content-center">
                    <span v-for="ext in extensions" :key="ext" class="bg-primary text-white px-2 py-1 rounded m-1">
                      .{{ext}}
                    </span>
                  </ul>
                </div>
              </div>

              <!-- <div class="form-group row">
                 <label for="" class="pt-2 col-md-4">{{showTitle}}</label>         
                     <div class="col-md-6">
                       <label for=""> Tipo de archivos permitidos: </label>
                      <ul v-if="extensions" class="tagd">
                          <span v-for="ext in extensions" :key="ext" class="bg-primary text-white px-2 py-1 rounded">
                          .{{ext}}</span>                             
                        </ul>  
                    </div> 
              </div> -->
                <div class="form-group row">
                   

                    <div id="drop-area" class="border border-info rounded p-4 text-center bg-light">
                        <form class="my-form text-center">
                            <p>{{message}}</p>
                            <input type="file" id="fileElem" multiple :accept="accept" 
                            @change="handleFiles($event.target.files)"
                            style="display: none;">
                            <label class="btn btn-primary" for="fileElem" :title="buttonSelectMessage">{{buttonSelectMessage}}</label>
                        </form>
                    </div>
                    <progress id="progress-bar" max=100 value=0 v-if="showProgress"></progress>
                        <div id="gallery">

                            
                        </div>
                          <div :class="tableContainerClass">
                            <table class="table " v-if="showTable">
                            <thead>
                                <tr><th>
                                    Nombre de archivo
                                    </th>
                                    <th>Tamaño</th>
                                    <th v-if="showButtonUploadInTableRow">
                                        Progreso
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item of filesToUpload" :key="item.index">
                                    <td>
                                       <span v-if="item.name">
                                           {{item.name}} 
                                           </span> 
                                    </td>
                                    <td>
                                        <span>
                                            {{item.size/1048576}} Mb
                                        </span>
                                          
                                    </td>

                                    <td>
                                        <button v-if="showButtonUploadInTableRow"  class="btn btn-sm btn-primary" 
                                            :disabled="isDisabled(item)"
                                            @click="emituploadSelectedFile(item)"
                                        >
                                            <i class="fa fa-upload"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                          </table>
                          </div>
                            <div class="row">
                                <button class="btn btn-primary" @click="subirArchivos" v-if="showButtonUploadFiles" :disabled="filesToUpload==undefined||filesToUpload.length==0">
                                    <i class="fa fa-upload"></i> Subir archivos</button>
                            </div>
                            <div>
                                <div class="alert alert-warning" v-if="advertencia">
                                        {{advertencia}}
                                </div>
                            </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
/**
* taken from https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
* modified by Daniel  Hdz. Fco. to be compatible with Vue and boostrap 4.
*
* Emite uploadSelectedFile cuando se da click en subir en un solo elemento
* Emite uploadFiles cuando se da click en subir todo
*
* https://developer.mozilla.org/en-US/docs/Web/API/File
*/


export default {
props: {
  enableScroll: {
    type: Boolean,
    default: false
  },
autoUploadSingleFile:{
  comment:'This prop set if when is a single file is emmited the selected upload',
  type:Boolean,
  default:true,
},
message: {
  type: String,
  default:
    "Selecciona multiples archivos con el cuadro de dialogo o soltando y arrastrando archivos dentro de la region con lineas."
},
accept: {
  type: String,
  default: "image/*"
},
buttonSelectMessage: {
  type: String,
  default: "Selecciona algunos archivos"
},
maxNumberOfFiles: {
  //indica cuanto es el maximo que pyede seleccionar, si selecciona mas de 1 se toma solo el primero
  type: Number,
  default: 1
},
maxNumberOfFilesXml:{
  type: Number,
  default: 1
},
maxNumberOfFilesZip:{
  type: Number,
  default: 1
},
showProgress: {
  type: Boolean,
  default: true
},
showGallery: {
  //cuando es imagen el usuario debera indicar este valor a true
  type: Boolean,
  default: true
},
showTable: {
  type: Boolean,
  default: false
},
showButtonUploadInTableRow: {
  type: Boolean,
  default: true
},
showButtonUploadFiles: {
  type: Boolean,
  default: true
},
showTitle: {
  type: String,
  default: "Subir archivos"
},
extensions: {
  type: Array,
  default: () => []
}
},
data: function() {
return {
  filesToUpload: [],
  progressBar: undefined,
  uploadProgress: [],
  dropArea: undefined,
  advertencia: undefined,
  isCfdi: false
};
},
mounted() {
this.dropArea = document.getElementById("drop-area");

["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
  //con esto prevenimis el cmpornamiento por defecto de los eventos de la lista sobre el elemento me
  this.dropArea.addEventListener(eventName, this.preventDefaults, false);
});
["dragenter", "dragover"].forEach(eventName => {
  this.dropArea.addEventListener(eventName, this.highlight, false);
});
["dragleave", "drop"].forEach(eventName => {
  this.dropArea.addEventListener(eventName, this.unhighlight, false);
});

// Handle dropped files
this.dropArea.addEventListener("drop", this.handleDrop, false);

//let uploadProgress = [];
//let progressBar = document.getElementById("progress-bar");
this.progressBar = document.getElementById("progress-bar");
 console.log("Received extensions:", this.extensions); 
},
methods: {
isDisabled(item){
  console.log("isDisabled");
  return item.uploading===true;
},
emituploadSelectedFile(item){
  console.log(item);
  //console.log(arguments);
 // this.$set(this.filesToUpload, item, item)
  item.uploading=true;
     console.log(item);
  this.$emit('uploadSelectedFile',item);

//now I can emmit the base64EncodedFile
const  toBase64 = file => new Promise((resolve, reject) => {
const reader = new FileReader();
reader.readAsDataURL(file);
reader.onload = () => resolve(reader.result);
reader.onerror = error => reject(error);
});
toBase64(item.nativeFile).then(response=>{
 let withoutMimeType=response.split(',')[1]
 //Now I can emit the file with or without url
 this.$emit('uploadSelectedBase64File',{
   base64:withoutMimeType,
   datarURL:response,
  item:item,  
 })
});

},
emitUploadSelectedFiles(item) {
    let UploadSelectedBase64Files = [];
    console.log('emitUploadSelectedFiles');
    console.log(item);

    item.uploading = true;
    this.$emit('uploadSelectedFiles', item);

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const promises = item.map(file => {
        return toBase64(file.nativeFile).then(response => {
            let withoutMimeType = response.split(',')[1];
            return {
                base64: withoutMimeType,
                datarURL: response,
                item: file
            };
        });
    });

    Promise.all(promises).then(resolvedFiles => {
        UploadSelectedBase64Files = resolvedFiles;

        const plainData = JSON.parse(JSON.stringify(UploadSelectedBase64Files));

        this.$emit('uploadSelectedBase64Files', plainData);
    }).catch(error => {
        console.error('Error procesando archivos:', error);
    });
},
// old
// emitUploadSelectedFiles(item){
//   let UploadSelectedBase64Files = [];
//   console.log('emitUploadSelectedFiles');
//   console.log(item);
//   item.uploading=true;
//   this.$emit('uploadSelectedFiles',item);

//   // now I can emmit the base64EncodedFile
//   const  toBase64 = file => new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });

//   item.forEach(file => {
//     toBase64(file.nativeFile).then(response=>{
//       let withoutMimeType=response.split(',')[1]
//       let archivo = {
//         base64:withoutMimeType,
//         datarURL:response,
//         item:file,  
//       }
//       UploadSelectedBase64Files.push(archivo);
//     });
//   });
//   // Now I can emit the file with or without url  
//   // this.$emit('uploadSelectedBase64Files', UploadSelectedBase64Files)
// },
subirArchivos() {
  //this.filesToUpload.forEach(this.uploadFile);
  this.$emit("uploadFiles", this.filesToUpload);
},
preventDefaults (e) {
  e.preventDefault();
  e.stopPropagation();
},
highlight () {
  //console.log(e);
  console.log('Drag over');
  this.dropArea.classList.add("highlight");
},

unhighlight () {
  console.log('Drag leave');
  this.dropArea.classList.remove("highlight");
},
handleDrop: function(e) {
  console.log("handleDrop");
  var dt = e.dataTransfer;
  var files = dt.files;

  this.handleFiles(files);
},
initializeProgress: function(numFiles) {
  console.debug("initializeProgress");
  console.debug(this);
  if (this.showProgress) {
    this.progressBar.value = 0;

    this.uploadProgress = [];

    for (let i = numFiles; i > 0; i--) {
      this.uploadProgress.push(0);
    }
  }
},
updateProgress: function(fileNumber, percent) {
  this.uploadProgress[fileNumber] = percent;
  let total =
    this.uploadProgress.reduce((tot, curr) => tot + curr, 0) /
    this.uploadProgress.length;
  console.debug("update", fileNumber, percent, total);
  this.progressBar.value = total;
},
// async validarArchivoXML(newFiles) {
//   let file = newFiles[0].nativeFile;

//   let esCfdiValido = await new Promise((resolve) => {
//     let reader = new FileReader();

//     reader.onload = function (event) {
//       let fileContent = event.target.result;

//       let parser = new DOMParser();
//       let xmlDoc = parser.parseFromString(fileContent, "text/xml");

//       let comprobante = xmlDoc.querySelector("cfdi\\:Comprobante, Comprobante");
//       let emisor = xmlDoc.querySelector("cfdi\\:Emisor, Emisor");
//       let receptor = xmlDoc.querySelector("cfdi\\:Receptor, Receptor");
//       let timbreFiscalDigital = xmlDoc.querySelector("tfd\\:TimbreFiscalDigital, TimbreFiscalDigital");
//       if (!comprobante && !emisor && !receptor && !timbreFiscalDigital) {
//         resolve(true);
//       } else {
//         resolve(false);
//       }
//     };
//     reader.readAsText(file);
//   });
//   return esCfdiValido;
// },
async handleFiles(files) {
  console.debug("handleFiles");
  console.log(files);
  files = [...files];

  const xmlFiles = files.filter(file => file.name.toLowerCase().endsWith('.xml'));
  const zipFiles = files.filter(file => file.name.toLowerCase().endsWith('.zip'));

  const otherFiles = files.filter(file => !file.name.toLowerCase().endsWith('.xml') && !file.name.toLowerCase().endsWith('.zip'));

  if (otherFiles.length > 0) {
    const nombresArchivos = otherFiles.map(f => f.name).join(", ");
    let mensaje = `Archivos inválidos serán ignorados: ${nombresArchivos}`;
    await this.$confirm.error(mensaje);
  }

  if (this.maxNumberOfFilesXml < xmlFiles.length) {
    this.advertencia =
      "El número de archivos XML permitidos es de " +
      this.maxNumberOfFilesXml +
      ". Número de archivos seleccionados es de " +
      xmlFiles.length +
      ". Se considerarán únicamente los primeros elementos." +
      " Número de elementos ignorados: " +
      (xmlFiles.length - this.maxNumberOfFilesXml);
    xmlFiles.splice(this.maxNumberOfFilesXml);
  }

  if (this.maxNumberOfFilesZip < zipFiles.length) {
    this.advertencia =
      "El número de archivos ZIP permitidos es de " +
      this.maxNumberOfFilesZip +
      ". Número de archivos seleccionados es de " +
      zipFiles.length +
      ". Se considerarán únicamente los primeros elementos." +
      " Número de elementos ignorados: " +
      (zipFiles.length - this.maxNumberOfFilesZip);
    zipFiles.splice(this.maxNumberOfFilesZip);
  }

  const filteredFiles = [...xmlFiles, ...zipFiles];
  this.initializeProgress(filteredFiles.length);

  let newFiles = [];
  filteredFiles.forEach((file, index) => {
    file.extension = file.name.substring(file.name.length - 3);
    file.index = file.name + index;

    const WrapperFile = {
      extension: file.extension,
      index: file.index,
      lastModified: file.lastModified,
      name: file.name,
      size: file.size,
      type: file.type,
      uploading: false,
      nativeFile: file
    };
    newFiles.push(WrapperFile);
  });

  if (this.showGallery) {
    filteredFiles.forEach(this.previewFile);
  }

  const extensions = this.extensions;
  this.filesToUpload = newFiles.filter(x =>  extensions.find(extension => extension.toLowerCase() === x.extension.toLowerCase()));

  let archivosNoAgregados = [];
  let berror = false;
  let errror = "No se agregó: ";

  newFiles.forEach(x => {
    
    console.log("x.extension", x.extension);
    extensions.find(extension => extension.toLowerCase() === x.extension.toLowerCase()) === undefined && archivosNoAgregados.push(x) && (errror += x.name + " ") && (berror = true);
     
  });

  if (berror) {
    await this.$confirm.error(errror);
    this.$emit('noEsUnCfdi');
  } else {
    if (this.autoUploadSingleFile && this.filesToUpload.length == 1) {
      this.emituploadSelectedFile(this.filesToUpload[0]);
    }else{
      this.emitUploadSelectedFiles(this.filesToUpload);
    }
  }
},
// async handleFiles(files) {
//   console.debug("handleFiles");
//   console.log(files);
//   files = [...files];

//   await this.$confirm.autoCloseSuccess("Archivo cargado", 1000);
//   if (this.maxNumberOfFiles < files.length) {
//     this.advertencia =
//       "El numero de archivos permitidos es de " +
//       this.maxNumberOfFiles +
//       ". Numero de archivos seleccionados es de " +
//       files.length;
//     this.advertencia +=
//       ". Se consideraran unicamente los primeros elementos" +
//       ". Numero de elementos ignorados: " +
//       (files.length - this.maxNumberOfFiles);
//     files = files.slice(0, this.maxNumberOfFiles);
//   }

//   this.initializeProgress(files.length);
//   var newFiles=[];
//   files.forEach(function(file, index) {
//     file.extension = file.name.substring(file.name.length - 3);
//     file.index = file.name + index;
//     //file.uploading=false;

//     var WrapperFile={
//       extension: file.extension,   
//       index:file.index ,
//       lastModified: file.lastModified,
//       name: file.name,
//       size: file.size,
//       type:file.type,
//       uploading: false,
//       nativeFile:file    //aqui esya el objeto File      
//       }
//     newFiles.push(WrapperFile);
//   });
  

//   //files.forEach(this.uploadFile);
//   if (this.showGallery) {
//     files.forEach(this.previewFile);
//   }

//   // if(newFiles.length >0){
//   //   if (newFiles[0].extension === "xml") {
//   //     this.isCfdi = await this.validarArchivoXML(newFiles);
//   //   }
//   // }

//   const extension = this.extensions;
//   this.filesToUpload = newFiles.filter(
//   //this.filesToUpload = files.filter(
//     x => extension.indexOf(x.extension) > -1
//   );
//   var archivosNoAgregados=[];
//   var berror=false;
//   var errror="No se agrego: ";
//   newFiles.forEach(
//  // files.forEach(
//     x =>{ 
      
//       if(extension.indexOf(x.extension)<0){
//         archivosNoAgregados.push(x);
//         errror+=x.name;
//         berror=true;
//       }
//     }
//   );
//   if(berror){
//     await this.$confirm.error(errror);
//     this.$emit('noEsUnCfdi');
//   }else{
//     if(this.autoUploadSingleFile && this.filesToUpload.length==1){
//       this.emituploadSelectedFile(this.filesToUpload[0])
//     }
//   }
//   // if(berror){
//   //   await this.$confirm.error(errror);
//   //   this.$emit('noEsUnCfdi');
//   // }else{
//   //   if(this.isCfdi){
//   //     this.$emit('noEsUnCfdi');
//   //     await this.$confirm.error('No se agrego porque no es el xml de un CFDI');
//   //   }else{
//   //     if(this.autoUploadSingleFile && this.filesToUpload.length==1){
//   //       this.emituploadSelectedFile(this.filesToUpload[0])
//   //     }
//   //   }
//   // }
//   //this.filesToUpload = files;
// },
previewFile: function(file) {
  console.debug("previewFile");
  let reader = new FileReader();
  console.debug(file);
  reader.readAsDataURL(file);
  reader.onloadend = function() {
    let div = document.createElement("div");
    let divBody = document.createElement("div");
    let img = document.createElement("img");

    img.src = reader.result;
    img.classList.add("d-upload-image");

    var span = document.createElement("span");
    span.innerHTML = file.name;
    div.classList.add("text-center");
    div.classList.add("card");
    div.classList.add("col-3");
    divBody.classList.add("body");

    divBody.appendChild(img);
    divBody.appendChild(span);
    div.appendChild(divBody);
    document.getElementById("gallery").appendChild(div);
  };
},
uploadFile: function() {
  /*
  console.debug("uploadFile");
  console.debug(index);
  var url = "https://api.cloudinary.com/v1_1/YOU/image/upload";
  var xhr = new XMLHttpRequest();
  var formData = new FormData();
  xhr.open("POST", url, true);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  var me = this;
  // Update progress (can be used to show progress indicator)
  xhr.upload.addEventListener("progress", function(e) {
    me.updateProgress(index, e.loaded * 100.0 / e.total || 100);
  });

  xhr.addEventListener("readystatechange", function(e) {
    if (xhr.readyState == 4 && xhr.status == 200) {
      me.updateProgress(index, 100); // <- Add this
    } else if (xhr.readyState == 4 && xhr.status != 200) {
      // Error. Inform the user
    }
  });

  formData.append("upload_preset", "YOU");
  formData.append("file", file);
  xhr.send(formData);
  */
}
},
  computed: {
    tableContainerClass() {
      return {
        'table-responsive': true,
        'overflow-auto custom-scroll': this.enableScroll
      }
     }
  }
};
</script>
<style scoped>
#drop-area.highlight {
border-color: #007bff !important; /* Utiliza un color primario más oscuro para el borde */
background-color: #cce5ff !important; /* Un azul más claro para el fondo */
}
  .custom-scroll {
    max-height: 400px;
  }
</style>